import { Box, Typography, TextField, InputAdornment } from "@mui/material";

import { ControlledSelect, ControlledSelectOption, makeSxStyles } from "ui";
import { FormikErrors } from "formik";
import { z } from "zod";

export const adminPutRegionServiceTimeReqDtoCustomSchema = z.object({
  percentage: z.number().min(1).max(100),
  serviceTypeChange: z.string(),
});

export type AdminPostServiceTimeDto = {
  serviceTypeChange?: string;
  percentage: number;
};

interface ServiceDurationDialogContainerProps {
  values: {
    serviceTypeChange?: string | undefined;
    percentage: number | undefined;
  };
  errors: {
    percentage?: string;
  };
  touched: {
    percentage?: boolean;
  };
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  serviceDuration: ControlledSelectOption[];
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  validateForm: (
    values?: AdminPostServiceTimeDto | undefined,
  ) => Promise<FormikErrors<AdminPostServiceTimeDto>>;
}

const ServiceDurationDialogContainer: React.FC<
  ServiceDurationDialogContainerProps
> = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  setFieldTouched,
  handleBlur,
  validateForm,
  serviceDuration,
}) => {
  const styles = useStyles();

  return (
    <Box sx={styles.gridDetailContainer}>
      <Typography fontWeight={600}>I want to</Typography>
      <ControlledSelect
        placeholderSelectEnabled={false}
        placeholder="Select Action"
        options={serviceDuration}
        value={values.serviceTypeChange}
        onChange={(value) => {
          setFieldValue("serviceTypeChange", value);
          setFieldTouched("serviceTypeChange", true);
          validateForm({
            percentage: values.percentage as number,
            serviceTypeChange: value,
          });
        }}
        onBlur={handleBlur}
      />
      <Typography fontWeight={600}>Duration by</Typography>
      <TextField
        id="percentage"
        type="number"
        value={values.percentage}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={touched.percentage && errors.percentage}
        error={touched.percentage && !!errors.percentage}
        margin="dense"
        variant="outlined"
        fullWidth
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  gridDetailContainer: {
    mt: "10px",
    mb: "10px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "10px",
    maxWidth: "100%",
    alignItems: "center",
  },
}));

export default ServiceDurationDialogContainer;
